export default {
  Goc: 1, // Hóa đơn gốc
  ThayThe: 2, // Hóa đơn thay thế
  DieuChinh: 3, // Hóa đơn điều chỉnh
  DaThayThe: 4, // Hóa đơn đã bị thay thế
  DaDieuChinh: 5, // Hóa đơn đã bị điều chỉnh
  Xoa: 6, // Hóa đơn đã bị xóa bỏ/hủy bỏ
  Unknown: 7, // Hóa đơn chưa xác định
};